import { createSelector } from "reselect";

const positionHasValidWarranty = (pos) => !pos.warrantyRequested || pos.warrantyClaim;
const positionHasValidReason = (pos) => pos.warehouseOrder || pos.serialNumber;
const positionIsEnabled = (pos) => pos.enabled;
const positionExists = (pos) => pos.exists;
const positionHasValidQuantity = (pos) => pos.quantity >= pos.quantityMinimum && pos.quantity % pos.quantityStep === 0;

export const getCart = (state) => state.shopping.cart;

export const getPositions = createSelector(getCart, (cart) => cart.positions);
export const getPositionCount = createSelector(getPositions, (positions) => positions.length);

export const getIsCartSyncing = createSelector(getCart, (cart) => cart.isSyncing);

export const getPositionPriceSum = createSelector(getCart, (cart) => cart.positionPriceSum);
export const getCurrency = createSelector(getCart, (cart) => cart.currency);

export const getCartPositionsEnabled = createSelector(getPositions, (positions) => positions.every(positionIsEnabled));
export const getPositionsReasonsEntered = createSelector(getPositions, (positions) => positions.every(positionHasValidReason));
export const getPositionsExist = createSelector(getPositions, (positions) => positions.every(positionExists));
export const getPositionsWarrantyValid = createSelector(getPositions, (positions) => positions.every(positionHasValidWarranty));
export const getPositionsQuantityValid = createSelector(getPositions, (positions) => positions.every(positionHasValidQuantity));

export const getCanRfq = createSelector(
  getCartPositionsEnabled,
  getPositionsReasonsEntered,
  getPositionsExist,
  getPositionsWarrantyValid,
  getPositionsQuantityValid,
  getIsCartSyncing,
  getPositionCount,
  (allEnabled, reasonsEntered, allExist, warrantyValid, quantityValid, isSyncing, count) => {
    return allEnabled & allExist && warrantyValid && quantityValid && reasonsEntered && !isSyncing && count > 0;
  }
);
